import { SpyneTrait, SpyneAppProperties, ChannelFetchUtil } from "spyne";
import { createAuth0Client, Auth0Client } from "@auth0/auth0-spa-js";
import { AuthViewLoginBtn } from "components/auth/auth-view-login-btn";
import { AuthViewProfile } from "components/auth/auth-view-profile";
//import {sendPostMsg} from '../../../../spyne-plugin-postmsg';
import { clone, mergeDeepLeft } from 'ramda';

let _dynamoDbApiURL;


export class AuthAppTraits extends SpyneTrait {

  constructor(context){
    let traitPrefix = "authApp$";

    super(context, traitPrefix);
  }

  static authApp$HelloWorld(){
    return "Hello World";
  }

  static authApp$OnOpenPreviewWindow(e){

    function openNewWindow(url, target = "_blank", features = "") {
      const newWindow = window.open(url, target, features);
      // If the popup was blocked by the browser, newWindow will be null
      if (!newWindow) {
        console.error(
            "Failed to open the new window (possibly blocked by a popup blocker).",
        );
        return null;
      }
      // Optional: focus the new window (some browsers may ignore this)
      newWindow.focus();

      return newWindow;
    }

    //const origin = "http://localhost:8070";
    const origin = SpyneAppProperties.getProp('previewSite');
    const popupRef = openNewWindow(
        origin,
        "previewWindow",
        "width=800,height=800",
    );
    this.props.windowPreview = popupRef;
    let num = 0;


  }


  static authApp$ConvertCardIdToTopicId(obj={}){

    function updateRouteParams(obj) {
      // 1. Loop through every key in the current object scope
      for (let key in obj) {

        // 2. Check for the specific condition to update
        if (key === 'routeName' && obj[key] === 'cardId') {
          obj[key] = 'topicId';
        }

        // 3. If the value is an object (and not null), recurse deeper
        else if (typeof obj[key] === 'object' && obj[key] !== null) {
          updateRouteParams(obj[key]);
        }
      }

      return obj;
    }


    const clonedObj = clone(obj);

    return updateRouteParams(clonedObj);
  }

  static authApp$$AddDefaultValuesToConfig(newObj={}){
    const defaultObjOld = {"debug":true,"channels":{"ROUTE":{"routes":{"routePath":{"routeName":"pageId","home":""}}},"WINDOW":{"events":["click","mouseover"]}}};


    const defaultObj = {
      debug: true,
      storageConfig: {
        storageKey: 'spyneAppStorage',
        theme: 'auto',
        themeDefaults: {
          colorScheme: 'auto',
          enableTransitions: true,
        },
      },

      channels: {
        WINDOW: {
          mediaQueries: {
            showMenuDrawer: `(min-width: 1024px)`,
          },
          events: [
            'click',
            'mouseover',
            'mouseenter',
            'message',
            'keyup',
            'keydown',
          ],
          customEvents: [{ name: 'spyne_cms_item_connected', buffer: 400 }],

          listenForScroll: true,
          listenForOrientation: true,
          debounceMSTimeForScroll: 50,
        },

        ROUTE: {
          add404s: true,
          routes: {
            routePath: {
              routeName: 'pageId',
              home: ''
            },
          },
        },
      },
    };

    const topiIdCheckObj = AuthAppTraits.authApp$ConvertCardIdToTopicId(newObj);


    const combinedObj = mergeDeepLeft(topiIdCheckObj, defaultObj);




    return JSON.parse(JSON.stringify(combinedObj))
  }


  static authApp$OnCreateAppCompleted(data) {
    const { userApps } = data;
   //console.log("USER RECORD IS ", { userApps, data });
    const action = "CHANNEL_AUTH_APP_CREATE_COMPLETED_SUCCESS_EVENT";
    this.props.userRecord = {userApps};
    this.sendInfoToChannel("CHANNEL_AUTH", { action }, action);
  }

  static authApp$CreateUserApp(config = {}, token) {
    _dynamoDbApiURL = SpyneAppProperties.getProp("apiDynamoDb");

    const conformedConfig = AuthAppTraits.authApp$$AddDefaultValuesToConfig(config.mainConfig);

    const userId = this.props?.userProfile.sub; // e.g. "auth0|abc123";
    const email = this.props?.userProfile.email;
    const name = this.props?.userProfile.name || userProfile.nickname || "Unknown";

    const requestType = "createUserApp";
    const requestData = { requestType, config: conformedConfig, userId, email, name };
  //console.log("REQ DATA ",{_dynamoDbApiURL, requestData, config, token}, this.props);




    const appGenFetch = new ChannelFetchUtil(
        {
          url: _dynamoDbApiURL,
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(requestData),
        },
        this.authApp$OnCreateAppCompleted.bind(this),
    );
  }

}

